import Api from '../Api';

import { url } from './config';
import { ServiceType } from './types';

const api = new Api<ServiceType>(url);

export default api;
